import {Frame} from "../common/Frame";
import Logo from "../../assets/logo.png";
import React, {useContext} from "react";
import {Button, Divider, Typography, useTheme} from "@mui/material";
import {AppContext} from "../../stores/AppStore";
import {observer} from "mobx-react";
import {D} from "../../Constants";
import {AppRoutes} from "../../AppRoutes";
import {ChevronRight} from "@mui/icons-material";

interface Props {
  children?: any;
  pathCrumbs?: [string | undefined | (() => any), any][];
  action?: React.ReactNode;
}

export const Header = observer((props: Props) => {
  const app = useContext(AppContext)!;
  const theme = useTheme();

  return <Frame
    style={{borderBottom: `solid 1px ${theme.palette.divider}`}}
    background={theme.palette.background.paper}
    appearance={'none'}
  >
    <Frame margin={'auto'} contentWidth row height={9} alignItems={'center'}>
      <img src={Logo} height={D.interactive(1.5)} alt="logo"/>
      <Divider orientation="vertical" style={{height: D.interactive(), margin: `0 ${D.unit(1)}`}}/>
      {props.children && <Frame row alignItems={'center'}>{props.children}</Frame>}
      {props.pathCrumbs && <Frame row alignItems={'center'}>
        {props.pathCrumbs.map((crumb, index) => <>
          <Button
            style={{minWidth: 0}}
            variant={'text'}
            size={'small'}
            href={typeof crumb[0] === 'string' ? crumb[0] as string : undefined}
            onClick={typeof crumb[0] === 'function' ? crumb[0] as () => any : undefined}
          >
            {crumb[1]}
          </Button>
          {index < props.pathCrumbs!.length - 1 && <ChevronRight style={{fontSize: '20px'}}/>}
        </>)}
      </Frame>}
      {!props.children && !props.pathCrumbs && <Typography variant="body1" component="div">
        Welcome, {app.auth.user?.first_name?.length ? `${app.auth.user?.first_name} ${app.auth.user?.last_name}` : app.auth.user?.username}!
      </Typography>}
      <Frame row gap={2} marginLeft={'auto'} alignItems={'center'}>
        {props.action}
        <Button onClick={() => app.auth.logout()} variant={'outlined'}>Logout</Button>
      </Frame>
    </Frame>
  </Frame>;
});
